<div class="table-view-table">
  <p-table
    [columns]="allFields"
    *ngIf="allFields?.length > 0 && reportRecordData?.length > 0"
    [value]="reportRecordData"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col" colspan="5">
          <div class="table-view-headers">
            <span class="title-bold">{{
              'recordPPT.currentTotal' | xTranslate: { recordLength: reportRecordData.length }
            }}</span>
            <span *ngIf="reportRecordData.length === 1; else records">{{
              ' ' + ('recordPPT.record' | xTranslate)
            }}</span>
            <ng-template #records>
              <span>{{ ' ' + ('recordPPT.records' | xTranslate) }}</span>
            </ng-template>
            <span>{{ ' - ' + ('recordPPT.totaling' | xTranslate) }}</span>
            <span class="title-bold" *ngIf="totalSizeField != null">
              {{
                reportRecordData
                  | reportFieldFormatter
                    : {
                        templateId: currentView.templateId,
                        field: totalSizeField,
                        joinString: true,
                        onlyUrl: false,
                      }
                  | async
              }}
            </span>
          </div>
        </th>
      </tr>
      <tr class="table-view-headers">
        <th scope="col" [ngClass]="{ pdfTable: isPDF }">#</th>
        <th
          scope="col"
          *ngIf="isEntityWithConfidentiality && confidentialityTmpl"
          [ngClass]="{ pdfTable: isPDF }"
          [ngClass]="{ 'tableView-confidentialityTmpl': confidentialityTmpl }"
        >
          <div class="compare-cell header confidentiality">
            {{ 'template.reportViewState' | xTranslate | uppercase }}
          </div>
        </th>
        <th scope="col" *ngFor="let col of columns" class="{{ col.class }}" [ngClass]="{ pdfTable: isPDF }">
          <span class="header-label"> {{ col.label | uppercase }}</span>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-catalog let-columns="columns" let-i="rowIndex">
      <tr [pReorderableRow]="i" (dragstart)="dragStartColumn(i)" (dragend)="dropColumn(i)" draggable="true">
        <!-- TECH DEBT (Sanjay): need to pass highlight field from configurations -->
        <td
          class="sno"
          [ngClass]="{
            'highlighted-date':
              catalog | highlightDatePipe: reportOptions.highlightDate : 'entity.edp_last_update_date',
            pdfTable: isPDF,
          }"
        >
          {{ i + 1 }}.
          <!-- NOTE: this i is being used to render font-awesome icon, but might be caught by sonarqube. Resolve it as "won't fix" -->
          <i *ngIf="!isPDF" class="fa fa-arrows move-record" pReorderableRowHandle></i>
          <mat-icon
            class="green-close"
            color="y-icon"
            svgIcon="close-icon-grey"
            (click)="removeRecord.emit(catalog)"
            *ngIf="!isPDF"
          ></mat-icon>
          <ng-container
            *ngIf="!isPDF"
            [ngTemplateOutlet]="templateProjectionMap | selectTemplateOutlet: 'miq-goes-to-record'"
            [ngTemplateOutletContext]="{
              classes: '',
              urlParams:
                catalog | reportRecordRouteFn: { templateId: currentView.templateId, entity: reportData.entity },
              content: goToIcon,
              navigateOptions: {
                type: 'static',
                ids: reportRecordData | extractRecordsFromReportRecordFn | pickDataFrom: 'data.entity.id',
                entity: reportData.entity,
              },
            }"
          ></ng-container>
          <ng-template #goToIcon>
            <mat-icon class="print-hidden open-in-new-tab-icon" color="y-icon" svgIcon="new-window"></mat-icon>
          </ng-template>
        </td>
        <td
          *ngIf="isEntityWithConfidentiality && confidentialityTmpl"
          [ngClass]="{ 'tableView-confidentialityTmpl': confidentialityTmpl }"
        >
          <ng-container
            *ngTemplateOutlet="
              confidentialityTmpl;
              context: { reportItem: catalog, displayLabel: true, isDataOnly: true }
            "
          ></ng-container>
        </td>
        <td *ngFor="let col of columns" [ngClass]="{ pdfTable: isPDF }" class="{{ col.dataClass }}">
          <div *ngIf="col.id === confidentialityId; else dataLabel">
            <ng-container
              *ngIf="
                templateProjectionMap &&
                  (templateProjectionMap | selectTemplateOutlet: 'miq-confidentiality-control-tmpl');
                else confidentialityLabel
              "
              [ngTemplateOutlet]="templateProjectionMap | selectTemplateOutlet: 'miq-confidentiality-control-tmpl'"
              [ngTemplateOutletContext]="{ reportItem: catalog, displayLabel: !isPDF, isDataOnly: true }"
            >
            </ng-container>
            <ng-template #confidentialityLabel>
              <span>{{ catalog.confidentiality }}</span>
            </ng-template>
          </div>
          <ng-template #dataLabel>
            <span
              class="table-data-cells"
              [ngClass]="{
                clickable:
                  editableFieldsService.editableTemplateAttributes[col.id] && !nonEditableFieldIds.includes(col.id),
              }"
              (click)="emitEditableFields($event, col.id, catalog.data)"
            >
              {{
                catalog
                  | reportFieldFormatter
                    : {
                        templateId: currentView.templateId,
                        field: col,
                        joinString: true,
                        onlyUrl: false,
                        reportOptions: reportOptions,
                      }
                  | async
              }}
            </span>
          </ng-template>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
